import { WebPlugin } from '@capacitor/core';
export class BluetoothPrinterWeb extends WebPlugin {
    connect() {
        throw this.unimplemented('Not implemented on web.');
    }
    connectAndPrint() {
        throw this.unimplemented('Not implemented on web.');
    }
    disconnect() {
        throw this.unimplemented('Not implemented on web.');
    }
    list() {
        throw this.unimplemented('Not implemented on web.');
    }
    print() {
        throw this.unimplemented('Not implemented on web.');
    }
}
//# sourceMappingURL=web.js.map